import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { Module } from '@/modules/core/app/constants/app.constants';
import { GuideState } from './guide.state';
import { getters } from './guide.getters';
import { mutations } from './guide.mutations';
import { actions } from './guide.actions';

VueXHelper.setStoreModule(Module.GUIDE, { actions, mutations, getters });

export const store = {
  namespaced: true,
  state: new GuideState(),
  getters,
  mutations,
  actions,
};
